<template>
  <div class="page-container main">
    <el-button @click="$router.back()" class="back-button"></el-button>
    <!--    <el-button @click="$router.back()">返回</el-button>-->
    <el-container class="container">
      <el-aside width="360px">
        <div class="agent-bg" @click="handleAgent">{{ ruleForm.agentName }}</div>
        <el-tree
          v-if="visible"
          lazy
          :load="loadNode"
          ref="tree"
          icon-class="''"
          :highlight-current="true"
          node-key="localId"
          :props="defaultProps"
          @node-click="handleNodeClick"
          style="margin-right: 5px"
        >
          <div class="tree-node" slot-scope="{ node }">
            <div>
              <img src="@assets/arrow-down.svg" v-if="node.level === 1" style="width: 20px;height:20px" alt="">
              <img src="@assets/folder.svg" v-if="node.level === 2" style="width: 20px;height:20px" alt="">
              <img src="@assets/doctor.svg" v-if="node.level === 3" style="width: 20px;height:20px" alt="">
              {{ node.label }}
            </div>
          </div>
        </el-tree>
      </el-aside>
      <el-container class="detail-content">
        <div class="qrcode" v-if="level === 2">
          <img :src="qrcode" style="width: 200px" alt="">
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="ruleForm"
        >
          <template v-if="level === 0">
            <el-form-item label="姓名" prop="agentName">
              <el-input v-model="ruleForm.agentName"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="ruleForm.gender">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="电话" prop="mobile">
              <el-input v-model="ruleForm.mobile"></el-input>
            </el-form-item>
            <el-form-item label="短信接收" prop="mobile">
              <el-tooltip content="多个手机号用逗号分隔" placement="right">
                <el-input v-model="ruleForm.notifyPhones" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="协议价" prop="email">
              <el-input v-model="ruleForm.agentPrice" style="width: 300px;" :disabled="!financePwd"></el-input>
              <el-button @click="onInputFinancePwd" :icon="!financePwd?'el-icon-edit':'el-icon-paperclip'">修改</el-button>
            </el-form-item>
            <el-form-item label="新订单管控" prop="balancePolicy">
              <el-select v-model="ruleForm.balancePolicy" placeholder="请选择">
                <el-option key="0" label="不限" :value="0"/>
                <el-option key="1" label="必须预存" :value="1"/>
              </el-select>
            </el-form-item>
            <el-form-item label="患者支付方式" prop="paymentMode">
              <el-select v-model="ruleForm.paymentMode" placeholder="请选择">
                <el-option key="0" label="精诊支付(默认)" :value="0"/>
                <el-option key="1" label="代理商二维码" :value="1"/>
              </el-select>
              <FileUploader v-show="ruleForm.paymentMode===1" bucket="dppublic" acceptFileType="image/*" ref="imgUploader1" title="代理商支付二维码" pathName="agent-images" @success="onUploadImageSuccess" @deleted="onImageDelected" />
            </el-form-item>
            <el-form-item v-if="ruleForm.paymentMode===2" label="代理商支付链接" prop="thirdPayUrl">
              <el-input v-model="ruleForm.thirdPayUrl"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="微信" prop="wechat">
              <el-input v-model="ruleForm.wechat"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input v-model="ruleForm.note"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="handleCancle">取消</el-button>
            </el-form-item>
          </template>
          <template v-else-if="level === 1">
            <el-form-item label="省份" prop="provinceName">
              {{ provinceName }}
            </el-form-item>
            <el-form-item label="城市" prop="cityName">
              {{ cityName }}
            </el-form-item>
            <el-form-item label="医院" prop="hospitalName">
              <template>{{ ruleForm.hospitalName }}</template>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <template>{{ ruleForm.note }}</template>
            </el-form-item>
          </template>
          <template v-else-if="level === 2">
            <el-form-item label="医院" prop="name">{{ ruleForm.hospitalName }}</el-form-item>
            <el-form-item label="科室" prop="departmentName">
              <template>{{ ruleForm.departmentName }}</template>
            </el-form-item>
            <el-form-item label="医生姓名" prop="docName">
              <template>{{ ruleForm.docName }}</template>
            </el-form-item>
            <el-form-item label="电话" prop="mobile">
              <template>{{ ruleForm.mobile }}</template>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <template>{{ ruleForm.email }}</template>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <template>{{ ruleForm.note }}</template>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="医院" prop="name">{{ ruleForm.hospitalName }}</el-form-item>
            <el-form-item label="科室" prop="departmentName">{{ ruleForm.departmentName }}</el-form-item>
            <el-form-item label="医生姓名" prop="docName">
              {{ ruleForm.docName }}
            </el-form-item>
            <el-form-item label="电话" prop="mobile">
              {{ ruleForm.mobile }}
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              {{ ruleForm.email }}
            </el-form-item>
            <el-form-item label="微信" prop="wechat">
              {{ ruleForm.wechat }}
            </el-form-item>
            <el-form-item label="备注" prop="note">
              {{ ruleForm.note }}
            </el-form-item>
          </template>
        </el-form>
      </el-container>
    </el-container>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="300px">
      <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
        请输入安全密码：
        <el-input type="password" style="width: 140px" v-model="verify"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verify = '';dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="delVisible" width="300px">
      <div class="del-title">删除后不可恢复，是否删除此{{ level === 2 ? '科室' : '医生' }}？</div>
      <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
        请输入安全密码：
        <el-input type="password" style="width: 140px" v-model="verify"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verify = '';delVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDelSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {task as taskApi} from '@/api';
import {areas} from '@/utils/areas';
import FileUploader from '@/comp/FileUploader';
import * as R from 'ramda';
export default {
  name: 'agentEdit',
  data() {
    const validateMobile = (rule, value, callback) => {
      if (String(value).length !== 11) {
        callback(new Error('请输入正确的电话号码！'));
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('电话号码为数字'));
        return;
      }
      callback();
    };
    return {
      visible: true,

      provinceName: '',
      cityName: '',
      qrcode: '',

      dialogVisible: false,
      delVisible: false,
      verify: '',

      defaultProps: {
        children: 'sub',
        label: 'name'
      },

      options: areas,

      cascaderProps: {
        value: 'code',
        label: 'name'
      },

      mobile: '',

      financePwd: '',
      ruleForm: {
        gender: '1',
        name: '',
        agentName: '',
        docName: '',
        localId: '',
        notifyPhones: '',
        agentPrice: '',
        balancePolicy: 0,
        paymentMode: 0,
        thirdPayQrImage: null,
        thirdPayUrl: null,
        provinceCity: [],
        wechat: '',
        mobile: '',
        hospitalName: '',
        departmentName: '',
        doctorId: '',
        email: '',
        note: ''
      },
      rules: {
        name: [{message: '请输入姓名', trigger: 'blur'}],
        hospitalName: [
          {required: true, message: '请输入医院名称', trigger: 'blur'}
        ],
        agentName: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        departmentName: [
          {required: true, message: '请输入科室名称', trigger: 'blur'}
        ],
        gender: [{required: true, message: '请选择性别', trigger: 'change'}],
        docName: [
          {required: true, message: '请输入医生姓名', trigger: 'blur'}
        ],
        provinceCity: [
          {
            type: 'array',
            required: true,
            message: '请选择省市',
            trigger: 'change'
          }
        ],
        localId: [{required: true, message: '请选择医院', trigger: 'change'}],
        mobile: [
          {required: true, message: '请选输入电话', trigger: 'blur'},
          {validator: validateMobile, trigger: 'blur'}
        ],
        wechat: [{message: '请选输入微信号', trigger: 'blur'}],
        email: [{message: '请输入电子邮件', trigger: 'blur'}],
        note: [{message: '请输入备注', trigger: 'blur'}]
      },

      hospitalTreeList: [],

      provinceCity: [],

      hospitalList: [],

      level: 0,
      localId: '',

      agentId: '',
      agentName: '',
      name: '',
      actionType: 'edit'
    };
  },
  components: {
    FileUploader,
  },
  methods: {
    handleRefreshTree() {
      this.visible = false;
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    handleAdd(e, node) {
      e.stopPropagation();
      this.actionType = 'add';
      this.level = 2;
      this.ruleForm = {
        name: '',
        departmentLocalId: this.localId || this.agentId,
        localId: this.agentId,
        mobile: '',
        email: '',
        docName: ''
      };
    },
    handleDel(e, {data}) {
      e.stopPropagation();
      this.level = data.level;
      this.localId = data.local_id;
      this.delVisible = true;
    },
    handleDelSubmit() {
      if (!this.verify) {
        this.$message.error('请输入安全密码！');
        return;
      }
      taskApi[this.level === 2 ? 'departmentDelete' : 'doctorDelete']({
        localId: this.localId,
        verify: this.verify
      }).then(res => {
        if (res.code === 10000) {
          this.$message.success('删除成功！');
          this.handleRefreshTree();
        }
      });
    },
    handleCancle() {
      this.resetForm('ruleForm');
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSubmit() {
      if (this.verify) {
        this.dialogVisible = false;
        this.submitForm('ruleForm');
      } else {
        this.$message.error('请输入安全密码！');
      }
    },
    handleNodeClick({local_id: localId, level}) {
      this.localId = localId;
      this.level = level;
      this.actionType = 'edit';
      if (level === 1) {
        this.hospitalDetail();
      } else if (level === 2) {
        this.departmentDetail();
      } else {
        this.doctorDetail();
      }
    },
    hospitalDetail() {
      taskApi
        .hospitalDetail({
          local_id: this.localId
        })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res;
            this.provinceName = data.provinceName;
            this.cityName = data.cityName;
            this.ruleForm.hospitalName = data.name;
            this.ruleForm.note = data.note;
          }
        });
    },
    hospitalEdit() {
      const params = {
        name: this.ruleForm.hospitalName,
        localId: this.localId,
        note: this.ruleForm.note
      };
      taskApi[this.actionType === 'edit' ? 'hospitalUpdate' : 'hospitalAdd'](params).then(res => {
        if (res.code === 10000) {
          this.$message.success('操作成功！');
          this.handleRefreshTree();
        }
      });
    },
    agentEdit() {
      taskApi.agentUpdate({
        verify: String(this.verify),
        local_id: this.agentId,
        name: this.ruleForm.agentName,
        gender: this.ruleForm.gender,
        mobile: this.ruleForm.mobile,
        email: this.ruleForm.email,
        notifyPhones: this.ruleForm.notifyPhones,
        agentPrice: this.ruleForm.agentPrice,
        paymentMode: this.ruleForm.paymentMode,
        thirdPayQrImage: this.ruleForm.thirdPayQrImage,
        thirdPayUrl: this.ruleForm.thirdPayUrl,
        balancePolicy: this.ruleForm.balancePolicy,
        financePwd: this.financePwd,
        wechat: this.ruleForm.wechat,
        note: this.ruleForm.note,
        changeMode: String(this.ruleForm.mobile) === this.mobile ? '' : '1',
      }).then(res => {
        if (res.code === 10000) {
          this.$message.success('操作成功！');
          this.handleRefreshTree();
        } else {
          this.verify = '';
        }
      })
        .catch(() => {
          this.verify = '';
        });
    },
    departmentDetail() {
      taskApi
        .departmentDetail({
          local_id: this.localId
        })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res;
            this.ruleForm.hospitalName = data.hospital_name;
            this.ruleForm.doctorId = data.doctor_local_id;
            this.ruleForm.departmentName = data.name;
            this.ruleForm.docName = data.docName;
            this.ruleForm.mobile = data.mobile;
            this.ruleForm.email = data.email;
            this.ruleForm.note = data.note;
            this.qrcode = data.qrcode;
          }
        });
    },
    agentDetail() {
      taskApi
        .agentDetail({
          local_id: this.agentId
        })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res;
            this.ruleForm.agentName = data.agentName;
            this.ruleForm.gender = String(data.gender);
            this.ruleForm.note = data.note;
            this.ruleForm.email = data.email;
            this.ruleForm.wechat = data.wechat;
            this.ruleForm.mobile = data.mobile;
            this.ruleForm.notifyPhones = data.notifyPhones;
            this.ruleForm.agentPrice = Number.parseFloat(data.agentPrice).toFixed(2);
            this.ruleForm.balancePolicy = data.balancePolicy;
            this.ruleForm.paymentMode = data.paymentMode;
            this.ruleForm.thirdPayUrl = data.thirdPayUrl;
            this.ruleForm.thirdPayQrImage = data.thirdPayQrImage;
            this.$refs.imgUploader1.setFile({ paths: [data.thirdPayQrImage] });
            this.mobile = data.mobile;
          }
        });
    },
    departmentEdit() {
      taskApi[this.actionType === 'edit' ? 'departmentUpdate' : 'departmentAdd']({
        name: this.ruleForm.departmentName,
        departmentLocalId: this.localId,
        doctorLocalId: this.ruleForm.doctorId,
        localId: this.agentId,
        mobile: String(this.ruleForm.mobile),
        email: this.ruleForm.email,
        docName: this.ruleForm.docName,
        order_abbr: String(+new Date()),
        note: this.ruleForm.note,
        verify: String(this.verify)
      }).then(res => {
        if (res.code === 10000) {
          this.$message.success('操作成功！');
          this.handleRefreshTree();
        }
      });
    },
    doctorDetail() {
      taskApi
        .doctorDetail({
          localId: this.localId
        })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res;
            this.ruleForm.hospitalName = data.hospital_name;
            this.ruleForm.departmentName = data.department_name;
            this.ruleForm.note = data.note;
            this.ruleForm.email = data.email;
            this.ruleForm.wechat = data.wechat;
            this.ruleForm.mobile = data.mobile;
            this.ruleForm.docName = data.name;
          }
        });
    },
    doctorEdit() {
      taskApi[this.actionType === 'edit' ? 'doctorUpdate' : 'doctorAdd']({
        hospital_name: this.ruleForm.hospitalName,
        department_name: this.ruleForm.departmentName,
        email: this.ruleForm.email,
        wechat: this.ruleForm.wechat,
        name: this.ruleForm.name,
        mobile: this.ruleForm.mobile,
        note: this.ruleForm.note
      }).then(res => {
        if (res.code === 10000) {
          this.$message.success('操作成功！');
          this.handleRefreshTree();
        }
      });
    },
    handleAgent() {
      this.level = 0;
      this.agentDetail();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.verify && this.mobile !== this.ruleForm.mobile) {
            this.dialogVisible = true;
            return;
          }
          if (this.level === 0) {
            this.agentEdit();
          } else if (this.level === 1) {
            this.hospitalEdit();
          } else if (this.level === 2) {
            this.departmentEdit();
          } else {
            this.doctorEdit();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleHospital(value) {
      taskApi.hospitalListName({}).then(res => {
        if (res.code === 10000) {
          const {data} = res;
          this.hospitalList = data;
          this.ruleForm.localId = '';
        }
      });
    },
    onInputFinancePwd() {
      this.$prompt('请输入财务密码', '修改协议价需要财务密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => { if (!val) return '财务密码为必填'; },
        inputPattern: /^.+$/,
        inputErrorMessage: '财务密码为必填'
      }).then((result) => {
        this.financePwd = result.value;
      });
    },
    async lazyLoad(node, resolve) {
      const {data} = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(
        data.map(e => ({
          value: e.code,
          label: e.name,
          leaf: e.level >= 2
        }))
      );
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.agentId) {
          const {data} = await taskApi.hospitalAgentList({
            local_id: this.agentId
          });
          const hospitalTreeList = data;
          hospitalTreeList.forEach(item => {
            item.level = 1;
            item.local_id = item.localId;
            item.hospitalName = item.name;
          });
          this.hospitalTreeList = hospitalTreeList;
          return resolve(this.hospitalTreeList);
        }
      }
      if (node.level === 1) {
        const {code, data} = await taskApi.departmentHospitalList({
          localId: node.data.local_id,
          agentId: this.agentId
        });
        if (code === 10000) {
          if (!data.sub) return resolve([]);
          return resolve(
            data.sub.map(e => ({
              name: e.name,
              local_id: e.local_id,
              level: 2,
              hospitalId: e.hospital_local_id,
              hospitalName: data.name,
              departmentName: e.name
            }))
          );
        }
      }
      if (node.level === 2) {
        const {code, data} = await taskApi.doctorDepartmentList({
          local_id: node.data.local_id
        });
        if (code === 10000) {
          return resolve(
            data.map(e => ({name: e.name, local_id: e.local_id, level: 3}))
          );
        }
      }
      if (node.level > 2) return resolve([]);
    },
    initData() {
      this.agentId = this.$route.params.id;
      this.level = 0;
      this.agentDetail();
    },
    onUploadImageSuccess({paths}) {
      this.ruleForm.thirdPayQrImage = R.head(paths);
    },
    onImageDelected({path}) {
      this.ruleForm.thirdPayQrImage = null;
    },
  },
  created() {
    this.initData();
  }
};
</script>
<style scoped>
.tree-node {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.container {
  min-height: calc(100vh - 64px);
  color: #fff;
}

.del-title {
  font-size: 16px;
  margin-bottom: 16px;
}

.agent-bg {
  display: flex;
  align-items: center;
  height: 26px;
  cursor: pointer;
  margin-left: 5px;
}

.agent-bg:focus {
  background-color: #f5f7fa;
}

.detail-content {
  border-left: 1px solid #3E4451;
  padding-top: 10px;
  position: relative;
}

.back-button {
  position: fixed;
  top: 16px;
  left: 200px;
  background-color: rgba(221, 236, 255, 0.1);
  border: none;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  padding: 0px;
  background-image: url('~@/assets/backto.png');
}

.qrcode {
  position: absolute;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/AgentEdit/index.vue